import { ContentCatalogFolder } from "@models/contentCatalogFolder.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class ContentCatalogFolderSerializer extends BaseSerializer {
  public deserialize(data: any): ContentCatalogFolder {
    const ccFolder = new ContentCatalogFolder();
    this._copyAttributes(ccFolder, data);

    return ccFolder;
  }
}
